<!-- 工单评价 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单编号')">
              <a-input :placeholder="$t('请输入工单编号')" v-model="queryParam.ticketsNum"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单紧急程度')">
              <j-dict-select-tag v-model="queryParam.ticketsEmergency" :placeholder="$t('请选择工单紧急程度')" dictCode="ticketsEmergency" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('是否已评价')">
              <a-select v-model="queryParam.isComments" :placeholder="$t('请选择是否已评价')">
                <a-select-option :value="0">{{ $t('否') }}</a-select-option>
                <a-select-option :value="1">{{ $t('是') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('tickets')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="ticketsState" slot-scope="text,record">
          <!-- 换表 -->
          <span v-if="record.ticketsType == 0">
            <template v-if="record.ticketsState == -1">
              {{ $t('已结束') }}
            </template>
            <template v-else>
              {{meterTypeList[text]}}
            </template>
          </span>
          <!-- 工程报装 -->
          <span v-if="record.ticketsType == 1">
            <template v-if="record.ticketsState == -1">
              {{ $t('已结束') }}
            </template>
            <template v-else>
              {{engineeringList[text]}}
            </template>
          </span>
          <!-- 故障报修 -->
          <span v-if="record.ticketsType == 2">
            <template v-if="record.ticketsState == -1">
              {{ $t('已结束') }}
            </template>
            <template v-else>
              {{repairList[text]}}
            </template>
          </span>
        </template>
        <template slot="createBy" slot-scope="text, record">
          <span>{{text?text:$t('微信端游客')}}</span>
        </template>
        <span slot="ticketsNum" slot-scope="text, record">
            <span>{{ text }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span @click.stop="copySampleNoLink(record.ticketsNum)" class="copySampleNo"><a-icon type="copy" /></span>
        </span>
        <span slot="ticketsEmergency" slot-scope="text, record">
          <a-tag color="green" v-if="text == 0">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="red" v-else-if="text == 1">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="orange" v-else-if="text == 2">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
        </span>

        <span slot="action" slot-scope="text, record">
          <!-- <TaskActHistoricDetailBtn :data-id="record.id"></TaskActHistoricDetailBtn>
          <a-divider type="vertical" /> -->
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <a-divider type="vertical" />
          <a @click="handleEvaluate(record)">{{record.isComments == 0?$t('评价'):$t('查看评价')}}</a>
        </span>

      </a-table>
    </div>
    <detailModal ref="detailForm" @ok="loadData"></detailModal>
    <EngineeringInstallationDetail ref="EngineeringInstallationDetailForm" @ok="loadData"></EngineeringInstallationDetail>
    <RepairDetailModal ref="RepairDetailModalForm" @ok="loadData"></RepairDetailModal>
    <WorkOrderEvaluationModal ref="WorkOrderEvaluationModalForm" @ok="loadData"></WorkOrderEvaluationModal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import workModal from './modules/workModal'
  import detailModal from './modules/detailModal.vue'
  import auditModal from './modules/auditModal.vue'
  import newMeterModal from './modules/newMeterModal.vue'
  import TaskActHistoricDetailBtn from './flowable/TaskActHistoricDetailBtn.vue'
  import EngineeringInstallationDetail from './modules/EngineeringInstallationDetail'//全部流程详情
  import RepairDetailModal from './modules/repairDetailModal'//故障报修详情
  import WorkOrderEvaluationModal from './modules/WorkOrderEvaluationModal'

  export default {
    name: 'WorkOrderEvaluation',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      workModal,
      detailModal,
      auditModal,
      newMeterModal,
      TaskActHistoricDetailBtn,
      EngineeringInstallationDetail,
      RepairDetailModal,
      WorkOrderEvaluationModal
    },
    data () {
      return {
        description: '工单评价页面',
        filterDictTextByCache: filterDictTextByCache,
        url: {
          list: "/jeecg-engineering/ticket/tickets/listComments",
        },
        dictOptions:{},
        superFieldList:[],
        queryParam: {},
      }
    },
    created() {},
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // 表头
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('是否已评价'),
            align:"center",
            dataIndex: 'isComments',
            width: 100,
            ellipsis: true,
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('否')
              }else if(t == 1){
                return this.$t('是')
              }
            },
          },
          {
            title: this.$t('工单编号'),
            align:"center",
            dataIndex: 'ticketsNum',
            scopedSlots:{customRender:'ticketsNum'},
            width: 200,
            ellipsis: true,
          },
          {
            title: this.$t('工单类型'),
            align:"center",
            dataIndex: 'ticketsType',
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('换表')
              }else if(t == 1){
                return this.$t('工程报装')
              }else if(t == 2){
                return this.$t('故障报修')
              }
            },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('工单紧急程度'),
            align:"center",
            dataIndex: 'ticketsEmergency',
            // customRender: function (text) {
            //   return filterDictTextByCache('ticketsEmergency', text)
            // },
            scopedSlots: { customRender: 'ticketsEmergency' },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('工单状态'),
            dataIndex: 'ticketsState',
            align:"center",
            width: 150,
            ellipsis: true,
            scopedSlots: { customRender: 'ticketsState' }
          },
          {
            title: this.$t('工单联系人'),
            align:"center",
            dataIndex: 'ticketsContact',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('联系电话'),
            align:"center",
            dataIndex: 'ticketsContactPhone',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('申请人'),
            align:"center",
            dataIndex: 'createBy',
            width: 150,
            ellipsis: true,
            scopedSlots: { customRender: 'createBy' }
          },
          {
            title: this.$t('申请时间'),
            align:"center",
            dataIndex: 'createTime',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('更新时间'),
            align:"center",
            dataIndex: 'updateTime',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('来源'),
            align:"center",
            dataIndex: 'sourceType',
            customRender: (text) => {
              if(text == 1){
              return this.$t('小程序')
            }else if(text == 2){
              return this.$t('公众号')
            }else{
              return 'PC'
            }
            },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:200,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      // 工单状态选项值映射
      meterTypeList() {
        return [this.$t('未开启'), this.$t('换表登记'), this.$t('旧表审核'), this.$t('绑定新表'), this.$t('安装'), this.$t('审核工单')]
      },
      engineeringList() {
        return ['未开启','报装申请','报装受理','报装勘察设计','报装预算','报装审批','报装收费','报装施工','报装验收','报装建档'].map(k => this.$t(k))
      },
      repairList() {
        return ['未开启','生成工单','接单','处理','归档'].map(k => this.$t(k))
      },
    },
    methods: {
      handleEvaluate(row){
        if(row.isComments == 0){
          this.$nextTick(()=>{
            this.$refs.WorkOrderEvaluationModalForm.init(row,'add');
          })
        }else{
          this.$nextTick(()=>{
            this.$refs.WorkOrderEvaluationModalForm.init(row,'detail');
          })
        }
      },
      // 详情
      handleDetail(row){
        this.$nextTick(()=>{
          if(row.ticketsType == 0){
            this.$refs.detailForm.init(row);
          }else if(row.ticketsType == 1){
            this.$refs.EngineeringInstallationDetailForm.init(row,true);
          }else if(row.ticketsType == 2){
            this.$refs.RepairDetailModalForm.init(row);
          }
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>